"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextDecoration = void 0;
const getTextDecoration = _ref => {
  let {
    appearance,
    renderAs,
    state
  } = _ref;
  // necessary for links that render to look like buttons
  if (appearance !== "link" && state.isHover) return "none";

  // handles links that render as links
  return renderAs === "a" && !state.isDisabled && (state.isActive || state.isHover || state.isFocus) ? "underline" : "none";
};
exports.getTextDecoration = getTextDecoration;
//# sourceMappingURL=getButtonTextDecoration.js.map